import React from "react";
import LogoutButton from "./LogoutButton";
import { withAuth0 } from "@auth0/auth0-react";

class AuthenticationButton extends React.Component {

  render() {
    const { isAuthenticated, isLoading, loginWithRedirect } = this.props.auth0;

    if (isLoading) {
      return <div>Loading...</div>;
    }

    if (!isAuthenticated) {
      loginWithRedirect();
      return <></>;
    }

    return <LogoutButton />;
  }
}

export default withAuth0(AuthenticationButton);
